import React from "react";
import TextInput from "../../../core/form/TextInput";

let ServiceDescriptionField = (props) => {

    return <TextInput
        name='description'
        label='form.service.description'
        multiline={true}
        {...props}
    />

}

export default ServiceDescriptionField